/**
 * El progreso de un check-in en segmentos (segments): uno por pregunta.
 *
 * Hechas en teal, la actual en navy, las que faltan en gris. Es **decorativo**:
 * el avance se dice en texto al lado ("Pregunta 2 de 4"), que es lo que se
 * anuncia. Repetirlo como barra accesible haría que el lector lo diga dos veces.
 */
export function Segmentos({
  total,
  actual,
}: {
  total: number;
  /** La pregunta en curso, desde 1. */
  actual: number;
}) {
  return (
    <div aria-hidden="true" className="flex gap-2">
      {Array.from({ length: total }, (_, indice) => {
        const numero = indice + 1;
        const clase = numero < actual ? 'bg-accent' : numero === actual ? 'bg-brand' : 'bg-track';
        // biome-ignore lint/suspicious/noArrayIndexKey: los segmentos son posiciones, no datos
        return <span className={`h-2 flex-1 rounded-full ${clase}`} key={indice} />;
      })}
    </div>
  );
}
